import { gql } from '@apollo/client';

export const CREATE_CAMPAIGNS = gql`
  mutation CreateCampaign($request: CreateCampaignRequest!) {
    CreateCampaign(request: $request) {
      id
    }
  }
`;

export const EDIT_CAMPAIGNS = gql`
  mutation UpdateCampaign($id: String!, $request: UpdateCampaignRequest!) {
    UpdateCampaign(id: $id, request: $request) {
      id
    }
  }
`;
